// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-expiry-container {
  width: 400px;
  height: auto;
  display: flex;
  background-color: #191818;
  padding: 16px;
  gap: 12px;
  border-radius: 5px;
  flex-direction: column !important;
  cursor: pointer;
}

.top-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.catname {
  font-size: 18px !important;
  font-weight: 500 !important;
  font-family: poppins !important;
  line-height: 25px !important;
}

.catname span {
  color: Gray;
  font-family: poppins;
  font-size: 16px;
  font-weight: 400;
}

.bottom-container {
  width: 100%;
  display: flex;
}

.expiry-date-container {
  /* width: 100%; */
  display: flex;
  gap: 16px;
}
.createdby-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}

.createdby {
  font-size: 12px !important;
  font-weight: 400 !important;
  font-family: karla !important;
  color: gray;
  display: flex;
  align-items: center;
  justify-content: end;
}

.expiry-designs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.design-count {
  font-size: 20px !important;
  font-family: karla !important;
  font-weight: 400 !important;
}

.active-session-iconsdiv {
  display: flex;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/ClientFlow/clientActiveExpiry.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".active-expiry-container {\n  width: 400px;\n  height: auto;\n  display: flex;\n  background-color: #191818;\n  padding: 16px;\n  gap: 12px;\n  border-radius: 5px;\n  flex-direction: column !important;\n  cursor: pointer;\n}\n\n.top-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n.catname {\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  font-family: poppins !important;\n  line-height: 25px !important;\n}\n\n.catname span {\n  color: Gray;\n  font-family: poppins;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.bottom-container {\n  width: 100%;\n  display: flex;\n}\n\n.expiry-date-container {\n  /* width: 100%; */\n  display: flex;\n  gap: 16px;\n}\n.createdby-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.createdby {\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  font-family: karla !important;\n  color: gray;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.expiry-designs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.design-count {\n  font-size: 20px !important;\n  font-family: karla !important;\n  font-weight: 400 !important;\n}\n\n.active-session-iconsdiv {\n  display: flex;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
